import { HandoverTypeEnum } from '../../enum/handover-type.enum';
import { HandoverHandoverSettings } from './handover-handover-settings';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateHandoverCommand {
  HandoverId: string;
  SiteId: string;
  CustomerId: string;
  HandOverType: HandoverTypeEnum;
  HandoverHandoverSettings: HandoverHandoverSettings[];
  Scaffolds: string[];
  OwnerId: string;
  HirePeriod: number;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


